const translation = {
  nav: {
    categories: "Kategorie",
    home: "Strona główna",
    guide: "Przewodnik",
    finds: "Znaleziska",
    safety: "Bezpieczeństwo",
    blog: "Blog",
  },
  hero: {
    headline: "Kakobuy Spreadsheet",
    subheadline: "Odkrywaj najlepsze produkty szybciej i bez chaosu",
    description: "Kompletna baza aktualnych list produktów, popularnych Kakobuy Finds oraz praktycznych porad zakupowych. Znajduj sprawdzone produkty, porównuj opcje i korzystaj z uporządkowanych spreadsheetów.",
    ctaPrimary: "Zobacz najnowszy Kakobuy Spreadsheet",
    ctaSecondary: "Przejrzyj najlepsze Kakobuy Finds",
    trustBadge1: "Aktualizowane listy produktów",
    trustBadge2: "Szczegółowe porównania",
    trustBadge3: "Niezależny przewodnik zakupowy",
    trustBadge4: "Bezpieczne wskazówki zakupowe",
  },
  comparison: {
    title: "Porównanie: Kakobuy Spreadsheet",
    subtitle: "Lepszy niż ręczne szukanie",
    description: "Zobacz, dlaczego tysiące użytkowników wybiera zorganizowane arkusze zamiast przeszukiwania setek stron ręcznie. Oszczędzaj czas i podejmuj lepsze decyzje zakupowe.",
    feature1: "Odkrywanie produktów",
    feature2: "Oszczędność czasu",
    feature3: "Organizacja",
    feature4: "Rekomendacje społeczności",
    spreadsheet: "Kakobuy Spreadsheet",
    traditional: "Tradycyjne wyszukiwanie",
  },
  categories: {
    title: "Kategorie produktów",
    goto: "Przejdź do kategorii",
    shoes: "Buty",
    hoodies: "Bluzy/Swetry",
    tshirts: "T-shirty",
    jackets: "Kurtki",
    pants: "Spodnie/Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna/Majtki",
    jersey: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne rzeczy",
  },
  seo: {
    tag: "Przewodnik SEO",
    title1: "Co to jest",
    title2: "Kakobuy Sheet?",
    title3: "Kompletna baza",
    description: "Kakobuy Spreadsheet to uporządkowana lista produktów pomagająca użytkownikom szybciej znaleźć popularne produkty, trendy oraz najlepsze propozycje zakupowe. Nasz przewodnik pomoże Ci zrozumieć, jak efektywnie korzystać z arkuszy, porównywać produkty i oszczędzać czas podczas zakupów online.",
    cta: "Przeczytaj przewodnik",
  },
  why: {
    title: "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
    card1Title: "Oszczędzaj czas",
    card1Desc: "Nie przeszukuj tysięcy produktów ręcznie. Wszystko masz w jednym miejscu.",
    card2Title: "Łatwe porównanie",
    card2Desc: "Porównuj ceny, jakość i popularność produktów w przejrzystym formacie.",
    card3Title: "Aktualne trendy",
    card3Desc: "Poznaj najczęściej wybierane produkty i bądź na bieżąco z nowościami.",
    card4Title: "Lepsza organizacja",
    card4Desc: "Wszystkie informacje o produktach uporządkowane w czytelnych arkuszach.",
  },
  testimonial: {
    label: "Opinia użytkownika",
    title1: "Dlaczego tysiące",
    title2: "użytkowników nam ufa",
    quote: "Kakobuy Spreadsheet całkowicie zmienił sposób, w jaki robię zakupy online. Zamiast spędzać godziny na przeszukiwaniu różnych stron, mam wszystko uporządkowane w jednym miejscu. Porównywanie produktów nigdy nie było łatwiejsze. Szczerze polecam każdemu, kto chce robić mądrzejsze zakupy i oszczędzać czas.",
    author: "Anna Kowalska, regularna użytkowniczka",
  },
  cta: {
    headline: "Kakobuy Spreadsheet",
    subheadline1: "Gotowy, aby odkrywać najlepsze produkty?",
    subheadline2: "Dołącz do społeczności mądrych kupujących już dziś.",
    button: "Uzyskaj dostęp do pełnego arkusza",
  },
  footer: {
    brand: "Kakobuy Finds",
    navTitle: "Nawigacja",
    home: "Strona główna",
    guide: "Przewodnik",
    finds: "Znaleziska",
    safety: "Bezpieczeństwo",
    blog: "Blog",
    socialTitle: "Social",
    newsletterTitle: "Zapisz się do newslettera",
    newsletterDesc: "Otrzymuj najnowsze aktualizacje i porady zakupowe.",
    placeholder: "Twój email",
    copyright: "Wszelkie prawa zastrzeżone.",
    privacy: "Polityka prywatności",
    terms: "Warunki korzystania",
  },
  guide: {
    title: "Kakobuy Spreadsheet Guide 2026 – Zaktualizowane listy produktów i ukryte znaleziska",
    back: "Powrót na stronę główną",
  },
};

export default translation;